import { DormitoryServicePath, ROOM_TYPES, SUBSIDIES } from "utils/constants";
import permissions from "app/permissions";
import EditStateSubsidy from "./Edit";

export const resources = {
  name: `${DormitoryServicePath}${ROOM_TYPES}/:typeId/${SUBSIDIES}/:id/edit`,
  title: "Редактиране на държавна субсидия",
  custom: <EditStateSubsidy />,
  permission: permissions.canManageDormitoryStateSubsidies,
};
